import getIndent from './getIndent';
import getCurrentCode from './getCurrentCode';
/**
 * Detect indentation in the current code block
 */

function getCurrentIndent(value) {
  var currentCode = getCurrentCode(value);

  if (!currentCode) {
    return '';
  }

  var text = currentCode.getTexts().map(function (t) {
    return t.text;
  }).join('\n');
  return getIndent(text);
}

export default getCurrentIndent;